import React, { Children, useState } from 'react'

import Cell from './components/Cell'
import Row from './components/Row'

import { useSort } from 'components/CommonUI/Table/hooks/useSort'
import { useCheckbox } from 'components/CommonUI/Table/hooks/useCheckBox'
import { TOTAL_ID_PREFIX, selectComponentTypes } from 'constants/tableConstants'
import CustomScroll from '../CustomScroll/CustomScroll'

export const Column = () => {
  return null
}

const TableStyled = (props) => {
  const {
    children, /// Table.Column components. Needs to render and read props
    data = [], //// Array of table data
    isSelectAction = false, //// if need control (checkbox or radioButton) rendered in first column
    handleSelectChange, /// function handled checkbox or radiobutton state. return data with select state
    defaultSortField = null, /// default sort field
    defaultSortDirection,
    selectComponent = selectComponentTypes.checkbox, /// select component. May be checkbox or radiobutton
    rowHoverColor, /// color for row color and control color
    classNameBodyRow = '', ///html class for body row tr tag
    isClickRow = false, /// focused table body row by click
    idKey = 'id',
    checkedKey = 'checked',
    isLoading = false,
  } = props

  const [focusedRowId, setFocusedRow] = useState(null)

  const [checkboxState, handleSelectState] = useCheckbox(
    data,
    handleSelectChange,
    selectComponent,
    checkedKey
  )

  const [sortData, sortedField, direction, handleSortClick] = useSort(
    checkboxState,
    defaultSortField,
    defaultSortDirection
  )

  const handleChangeSelect = (e) => {
    handleSelectState(e.target.dataset.id)
  }

  const handleClickRow = (id) => () => {
    setFocusedRow((prev) => (prev === id ? null : id))
  }

  const _tabelData = sortData

  return (
    <div className="table_container">
      <CustomScroll className="table_scroll_wrap">
        <table className="table" cols={children.length}>
          <TableHeader
            child={children}
            handleSortClick={handleSortClick}
            sortedField={sortedField}
            direction={direction}
          />
          {!data.length && (
            <tfoot className="table_footer">
              <tr>
                <th colSpan="100">
                  {isLoading ? 'Loading...' : 'No data of table'}
                </th>
              </tr>
            </tfoot>
          )}
          <tbody onChange={handleChangeSelect}>
            {_tabelData.map((r, index) => {
              const isTotalRow = r[idKey].includes(TOTAL_ID_PREFIX)
              const totalRowClassName = isTotalRow ? 'total_row' : ''

              return (
                <Row
                  key={r[idKey] + index}
                  onClick={isClickRow ? handleClickRow(r[idKey]) : null}
                  className={`body_row ${totalRowClassName} ${classNameBodyRow}`}
                  hoverColor={rowHoverColor}
                  isSelected={
                    selectComponent === selectComponentTypes.radioButton &&
                    r.checked
                  }
                  isFocusRow={isClickRow && focusedRowId === r[idKey]}
                >
                  {Children.map(children, (child, index) => {
                    if (child?.type !== Column) return null
                    const { props } = child

                    const _isSelectAction = isSelectAction && index === 0

                    const rowFocusedData = {}

                    if (isClickRow) {
                      rowFocusedData.isRowFocused =
                        focusedRowId === r[idKey] ? true : false
                    }

                    return (
                      <Cell
                        value={r[props.dataField]}
                        isSelectAction={_isSelectAction}
                        selectComponent={selectComponent}
                        data={{
                          ...r,
                          controlColor: rowHoverColor || r.color,
                          ...rowFocusedData,
                        }}
                        valuesStringType={props.valuesStringType}
                        valuesType={props.valuesType}
                        cellRender={props.cellRender}
                        align={props.align}
                        width={props.width}
                        className={props.classNameBodyCell}
                      />
                    )
                  })}
                </Row>
              )
            })}
          </tbody>
        </table>
      </CustomScroll>
    </div>
  )
}

const TableHeader = ({ child, handleSortClick, sortedField, direction }) => {
  return (
    <thead>
      <Row className="header_row">
        {Children.map(child, (child) => {
          if (child?.type === Column) {
            const { props } = child
            return (
              <Cell
                value={props.caption}
                isHeader
                isSort={props.isSort}
                onClickSort={handleSortClick}
                dataField={props.dataField}
                sortedField={sortedField}
                direction={direction}
                align={props.align}
                width={props.width}
              />
            )
          }

          return null
        })}
      </Row>
    </thead>
  )
}

export default TableStyled
